import { render, staticRenderFns } from "./PatientAlertRep.vue?vue&type=template&id=20099408&"
import script from "./PatientAlertRep.vue?vue&type=script&lang=js&"
export * from "./PatientAlertRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientAlertRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports